<template>
  <vue-select style="width: 100%" :value="value" @search="getOptions" id="product-brand-id"
    :options="$store.state.product.products" label="label" class="select-x" placeholder="cari berdasarkan kata kunci"
    @input="changed" />
</template>

<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { convertObjToString } from "../lib/helpers";

export default {
  components: {
    VueSelect,
  },
  name: "ProductSelector",
  props: ["value", "query"],
  created () {
    this.$store.dispatch('product_get_items', '')
  },
  methods: {
    init (q) {
      var qAdd = `q=${q}`;
      if (this.query) {
        qAdd += "&" + convertObjToString(this.query);
      }
      this.$store.dispatch('product_get_items', qAdd)
    },
    getOptions (search, loading) {
      loading(true);
      this.init(search);
      loading(false);
    },
    changed (evt) {
      this.$emit("input", evt);
    },
  },
};
</script>

<style scoped>

</style>
